const BASE_BUCKET =
  process.env.REACT_APP_ENV === 'production'
    ? process.env.REACT_APP_S3_BUCKET_PROD
    : process.env.REACT_APP_S3_BUCKET_DEV

export const s3Upload = async (
  key: string,
  file: any,
  bucket?: string
): Promise<{ Location: string; Key: string; Bucket: string } | null> => {
  if (!key) {
    return null
  }
  const AWS = require('aws-sdk')
  AWS.config.update({
    region: 'us-east-1',
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: 'us-east-1:f165c051-74b8-472a-98d4-0eb8b47f996a'
    })
  })
  const s3Bucket = `${BASE_BUCKET}/${bucket ? bucket : 'uploads'}`
  return new Promise((approve, reject) => {
    const s3 = new AWS.S3({ useAccelerateEndpoint: false })
    const params = { Bucket: s3Bucket, Key: key, Body: file }
    s3.upload(params, (err: any, data: any) => {
      if (err) {
        return reject(err)
      }
      return approve(data)
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/aws.ts